/* eslint-disable react/no-danger,react/no-unescaped-entities,jsx-a11y/href-no-hash,react/no-array-index-key,prefer-template,jsx-a11y/no-noninteractive-element-interactions */
import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Query} from "react-apollo";
import {gql} from "apollo-boost";
import PropTypes from 'prop-types';
import {LinkedinShareButton, TwitterShareButton} from "react-share";
import ReactPlayer from "react-player";
import {filterHTML, filterResource, filterUrlSocial, isInternalLink} from "../../helpers/filters";
import {getVideoId} from "../../helpers/video";
import InlineModalVideo from "../../components/InlineModalVideo";
import API from '../../config/API';
import "./HomePage.scss";
import {trackEventByUrl} from "../../helpers/events";

const GET_PAGE_INNER = `    
entityLabel
... on NodePageHomepage {
  fieldHeroType
  fieldBackgroundVideoLink {
    ... on FieldNodeFieldBackgroundVideoLink {
      uri
    }
  }
  fieldHomepageHero {
    ... on FieldNodeFieldHomepageHero {
      entity {
        entityId
        ... on ParagraphComponentHomepageHero {
          fieldTxtHeadline
          fieldHtmlBody {
            processed
          }
          background:fieldObjectImgMedia {
            ... on FieldParagraphFieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
            }
          }
          fieldHeroBoxes {
            ... on FieldParagraphFieldHeroBoxes {
              entity {
                entityId
                ... on ParagraphInnerHomepageHeroBox {
                  image:fieldObjectImgMedia {
                      entity {
                        ... on MediaImage {
                          fieldMediaImage {
                            width
                            height
                            url
                            alt
                            title
                          }
                        }
                      }
                  }
                  fieldTxtHeadline
                  fieldTxtSubTitle
                  fieldLink {
                    ... on FieldParagraphFieldLink {
                      title
                      url {
                        path
                        routed
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  fieldHomepageSplitBoxes {
    ... on FieldNodeFieldHomepageSplitBoxes {
      entity {
        entityId
        ... on ParagraphInnerHomepageSplitBox {
          fieldTxtHeadline
          fieldTxtSubTitle
          background:fieldObjectImgMedia {
            ... on FieldParagraphFieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
            }
          }
          fieldSecondaryHeadlineBelow
          fieldTwitterShareLink {
            ... on FieldParagraphFieldTwitterShareLink {
              title
              url {
                path
              }
            }
          }
          fieldLinkedinShare {
            ... on FieldParagraphFieldLinkedinShare {
              url {
                path
              }
            }
          }
          fieldMoreInfoLink {
            ... on FieldParagraphFieldMoreInfoLink {
              title
              url {
                path
              }
            }
          }
        }
      }
    }
  }
  fieldHomepageLowerPhotoBox {
    ... on FieldNodeFieldHomepageLowerPhotoBox {
      entity {
        entityId
        ... on ParagraphComponentHpLowerPhotoBox {
          fieldTxtHeadline
          fieldTxtSubTitle
          fieldColorText
          background:fieldObjectImgMedia {
            ... on FieldParagraphFieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
            }
          }
          fieldLinkButton {
            title
            ... on FieldParagraphFieldLinkButton {
              url {
                path
              }
            }
          }
        }
      }
    }
  }
  fieldHomepageBottomCallout {
    ... on FieldNodeFieldHomepageBottomCallout {
      entity {
        entityId
        ... on ParagraphComponentHpBottomCallout {
          fieldTxtHeadline
          fieldTxtSubTitle
          fieldLinkButton {
            title
            ... on FieldParagraphFieldLinkButton {
              url {
                path
                routed
              }
            }
          }
        }
      }
    }
  }
}
`;

const GET_PAGE = gql`
    query nodeById($id: String!) {
        nodeById(id: $id) {
            ${GET_PAGE_INNER}
        }
    }
`;

const GET_REVISION = gql`
    query nodeRevisionById($id: String!) {
        nodeById:nodeRevisionById(id: $id) {
            ${GET_PAGE_INNER}
        }
    }
`;

class HomePage extends Component {

  
    static propTypes = {
      revisionId: PropTypes.string
    };
    
    static defaultProps = {
      revisionId: ''
    };
    
    state = {
      videoStatus: 'playing'
    }

    getLowerPhotoBoxLink = (linkObject, index) => {
        if (!linkObject.url || !linkObject.url.path) return null;

        const videoId = getVideoId(linkObject.url.path);
        if (videoId) return (
            <InlineModalVideo key={index}
                              videoId={videoId}
                              videoUrl={linkObject.url.path}
                              title={linkObject.title || 'Learn More'}
                              className="button button--white"/>
        );

        if (isInternalLink(linkObject.url.path)) {
            return (
                <div>
                    <a onClick={() => trackEventByUrl(linkObject.url.path, linkObject.title || 'Learn more')} key={index} href={linkObject.url.path} className="button button--white">
                        {linkObject.title || 'Learn more'}
                    </a>
                </div>
            )
        }

        return (
            <div>
                <a onClick={() => trackEventByUrl(linkObject.url.path, linkObject.title || 'Learn more')} key={index} href={linkObject.url.path} target="_blank" rel="noopener noreferrer" className="button button--white">
                    {linkObject.title || 'Learn more'}
                </a>
            </div>
        );
    };

    getSplitBoxLink = linkObject => {
        if (!linkObject.url || !linkObject.url.path) return null;

        const videoId = getVideoId(linkObject.url.path);
        if (videoId) return (
            <InlineModalVideo videoId={videoId}
                              videoUrl={linkObject.url.path}
                              title={linkObject.title || 'Watch the Video'}
                              className="text-cta"/>
        );

        if (isInternalLink(linkObject.url.path)) {
            return (
                <a href={linkObject.url.path} className="text-cta" onClick={() => trackEventByUrl(linkObject.url.path, linkObject.title || 'Read the Article')}>
                    {linkObject.title || 'Read the Article'}
                </a>
            )
        }

        return (
            <a href={linkObject.url.path} target="_blank" rel="noopener noreferrer" className="text-cta" onClick={() => trackEventByUrl(linkObject.url.path, linkObject.title || 'Read the Article')}>
                {linkObject.title || 'Read the Article'}
            </a>
        );
    };

    getBoxBackground = box => box.entity.background && box.entity.background.entity && box.entity.background.entity.fieldMediaImage && box.entity.background.entity.fieldMediaImage.url ? box.entity.background.entity.fieldMediaImage.url : '';

    toggleBackgroundVideo = () => {
      if(this.state.videoStatus === 'playing') {
        this.setState({videoStatus: 'paused'});
        this.stopAllYouTubeVideos();
      } else {
        this.setState({videoStatus: 'playing'});
        this.playAllYouTubeVideos();;
      }
    }

    stopAllYouTubeVideos = () => { 
      const iframes = document.querySelectorAll('iframe');
      Array.prototype.forEach.call(iframes, iframe => { 
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', 
      func: 'stopVideo' }), '*');
     });
    }

    playAllYouTubeVideos = () => { 
      const iframes = document.querySelectorAll('iframe');
      Array.prototype.forEach.call(iframes, iframe => { 
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', 
      func: 'playVideo' }), '*');
     });
    }

    render() {
        const {revisionId} = this.props;
        return (
            <Query asyncMode query={!revisionId ? GET_PAGE : GET_REVISION} variables={{ id: !revisionId ? API.homePageId : revisionId }}>
                {({ loading, error, data }) => {
                    if (loading) return (<div className="pageLoader"/>);
                    if (error) return <div>{error}</div>;

                    const page = data.nodeById;
                    const hero = page.fieldHomepageHero.entity;
                    const splitBoxes = page.fieldHomepageSplitBoxes;
                    const lowerPhotoBox = page.fieldHomepageLowerPhotoBox.entity;
                    const bottomCallout = page.fieldHomepageBottomCallout.entity;
                    const heroType = page.fieldHeroType;
                    const backgroundVideoLink = page.fieldBackgroundVideoLink && page.fieldBackgroundVideoLink.uri ? page.fieldBackgroundVideoLink.uri : null;
                    const heroBg = hero.background && hero.background.entity && hero.background.entity.fieldMediaImage && hero.background.entity.fieldMediaImage.url ? hero.background.entity.fieldMediaImage.url : '';
                    const lowerPhotoBoxBg = lowerPhotoBox.background && lowerPhotoBox.background.entity && lowerPhotoBox.background.entity.fieldMediaImage && lowerPhotoBox.background.entity.fieldMediaImage.url ? lowerPhotoBox.background.entity.fieldMediaImage.url : '';

                    const heroVideoId = getVideoId(backgroundVideoLink);
                    const heroVideoUrl = heroVideoId.type === 'vimeo' ? `https://player.vimeo.com/video/${heroVideoId.id}?title=0&byline=0&portrait=0&autoplay=1` : backgroundVideoLink;

                    return (
                        <div className="page-home">

                            <Helmet>
                                <title>{page.entityLabel ? page.entityLabel : 'Home'} | MarketAxess</title>
                            </Helmet>

                            <div className="main">

                                <section className="home__intro">
                                	<span className="home__introOverlay"/>

                                    {!heroType || heroType === 'standard' ? (
                                    <div className="hero container">

                                        <div className="hero__text">
                                          {hero.fieldTxtHeadline && (
                                              <h1>{hero.fieldTxtHeadline}</h1>
                                          )}

                                          {hero.fieldHtmlBody && hero.fieldHtmlBody.processed && (
                                              <div dangerouslySetInnerHTML={{__html: filterHTML(hero.fieldHtmlBody.processed)}}/>
                                          )}

                                          <a className="button button--blue" href="/contact-us">Schedule a demo</a>
                                        </div>

                                        <div className="hero__image">
                                          {heroBg && (
                                            <img src={filterResource(heroBg)} alt=""/>
                                          )}
                                        </div>

                                    </div>
                                    ) : null}

                                    {heroType === 'video' ? (
                                      <div className="videoHero__container">
                                        <div className="videoHero">
                                          <ReactPlayer className="videoHero__player"
                                            controls={false}
                                            autoplay
                                            width='100%'
                                            height='100%'
                                            loop
                                            url={heroVideoUrl}
                                            muted
                                            playing={this.state.videoStatus === 'playing'}
                                          />
                                          <div className="videoHero__overlay" />
                                        </div>
                                        <div className="videoHero__textContainer">
                                          <div className="videoHero__text">
                                            {hero.fieldTxtHeadline && (
                                                <h1>{hero.fieldTxtHeadline}</h1>
                                            )}

                                            {hero.fieldHtmlBody && hero.fieldHtmlBody.processed && (
                                                <div dangerouslySetInnerHTML={{__html: filterHTML(hero.fieldHtmlBody.processed)}}/>
                                            )}

                                            {this.state.videoStatus === 'playing' ? (
                                              <span id="video-controls-text" className="screen-reader-text">Pause Video</span>
                                            ) : (
                                              <span id="video-controls-text" className="screen-reader-text">Play Video</span>
                                            )}
                                            <button className={`videoHero__button${this.state.videoStatus === 'playing' ? '' : ' videoHero__button--play'}`} onClick={this.toggleBackgroundVideo} />
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}

                                </section>

                                <div className="introFeatured__container">
                                  <div className="container">
                                    {hero.fieldHeroBoxes.length ? hero.fieldHeroBoxes.map((box, index) => (
                                        <div className="introFeatured__module" id={`introFeatured__module__${box.entity.entityId || index}`} key={`introFeatured__module__${box.entity.entityId || index}`}>
                                            {box.entity.image && box.entity.image.entity && box.entity.image.entity.fieldMediaImage && box.entity.image.entity.fieldMediaImage.url ? (
                                                <div className="introFeatured__moduleImage">
                                                    {box.entity.fieldLink && box.entity.fieldLink.url && box.entity.fieldLink.url.path ? (
                                                        <a title={box.entity.fieldLink.title || 'Read More'} href={box.entity.fieldLink.url.path} className="introFeatured__moduleImageLink" onClick={() => trackEventByUrl(box.entity.fieldLink.url.path, box.entity.fieldLink.title || 'Read More')}>
                                                            <img src={box.entity.image.entity.fieldMediaImage.url} alt={box.entity.image.entity.fieldMediaImage.alt} />
                                                        </a>
                                                    ) : (
                                                        <img src={box.entity.image.entity.fieldMediaImage.url} alt={box.entity.image.entity.fieldMediaImage.alt} />
                                                    )}
                                                </div>
                                                
                                            ) : null}
                                            {box.entity.fieldTxtHeadline && (
                                                <h3 dangerouslySetInnerHTML={{__html: filterHTML(box.entity.fieldTxtHeadline)}}/>
                                            )}
                                            {box.entity.fieldTxtSubTitle && (
                                                <h4 dangerouslySetInnerHTML={{__html: filterHTML(box.entity.fieldTxtSubTitle)}}/>
                                            )}
                                            {box.entity.fieldLink && box.entity.fieldLink.url && box.entity.fieldLink.url.path && (
                                                <a href={box.entity.fieldLink.url.path} className="text-cta" onClick={() => trackEventByUrl(box.entity.fieldLink.url.path, box.entity.fieldLink.title || 'Read More')}>
                                                    {box.entity.fieldLink.title || 'Read More'}
                                                </a>
                                            )}
                                        </div>
                                    )) : null}
                                  </div>
                                </div>

                                <section className="home__featured">

                                    {splitBoxes.length ? splitBoxes.map((box, index) => (
                                        <section className="home__featuredContainer" key={`home__featuredContainer__${box.entity.entityId || index}`}>
                                            <div className="home__featuredContentModule home__featuredContentModule--image" style={{backgroundImage: `url(${filterResource(this.getBoxBackground(box))})`}} />

                                            <div className="home__featuredContentModule home__featuredContentModule--text">
                                                {box.entity.fieldTxtSubTitle && (
                                                    <p dangerouslySetInnerHTML={{__html: filterHTML(box.entity.fieldTxtSubTitle)}}/>
                                                )}
                                                {box.entity.fieldTxtHeadline && (
                                                    <h2 dangerouslySetInnerHTML={{__html: filterHTML(box.entity.fieldTxtHeadline)}}/>
                                                )}
                                                {box.entity.fieldSecondaryHeadlineBelow && (
                                                    <h4 dangerouslySetInnerHTML={{__html: filterHTML(box.entity.fieldSecondaryHeadlineBelow)}}/>
                                                )}

                                                <div className="home__featuredContentCTA">

                                                    {
                                                      box.entity.fieldMoreInfoLink &&
                                                      box.entity.fieldMoreInfoLink.url &&
                                                      box.entity.fieldMoreInfoLink.url.path &&
                                                        this.getSplitBoxLink(box.entity.fieldMoreInfoLink)
                                                    }

                                                    <ul className="home__featuredContentSocial">

                                                        {box.entity.fieldTwitterShareLink && box.entity.fieldTwitterShareLink.url && box.entity.fieldTwitterShareLink.url.path && (
                                                            <li onClick={() => trackEventByUrl(filterUrlSocial(box.entity.fieldTwitterShareLink.url.path), box.entity.fieldTwitterShareLink.title || 'Share to Twitter', 'Social Share')}>
                                                                <TwitterShareButton title={box.entity.fieldTwitterShareLink.title} url={filterUrlSocial(box.entity.fieldTwitterShareLink.url.path)}>
                                                                    <i className="fab fa-x-twitter" />
                                                                </TwitterShareButton>
                                                            </li>
                                                        )}

                                                        {box.entity.fieldLinkedinShare && box.entity.fieldLinkedinShare.url && box.entity.fieldLinkedinShare.url.path && (
                                                            <li onClick={() => trackEventByUrl(filterUrlSocial(box.entity.fieldLinkedinShare.url.path), box.entity.fieldLinkedinShare.title || 'Share to LinkedIn', 'Social Share')}>
                                                                <LinkedinShareButton url={filterUrlSocial(box.entity.fieldLinkedinShare.url.path)}>
                                                                    <i className="fab fa-linkedin" />
                                                                </LinkedinShareButton>
                                                            </li>
                                                        )}

                                                    </ul>
                                                </div>
                                            </div>
                                        </section>
                                    )) : null}

                                </section>

                                <section className="home__callout--left" style={{backgroundImage: `url(${filterResource(lowerPhotoBoxBg)})`}}>
                                    <div className="container">

                                        <div className="callout__textModule">
                                            {lowerPhotoBox.fieldTxtHeadline && (
                                                <h3 style={{color: lowerPhotoBox.fieldColorText}} dangerouslySetInnerHTML={{__html: filterHTML(lowerPhotoBox.fieldTxtHeadline)}}/>
                                            )}
                                            {lowerPhotoBox.fieldTxtSubTitle && (
                                                <p style={{color: lowerPhotoBox.fieldColorText}} dangerouslySetInnerHTML={{__html: filterHTML(lowerPhotoBox.fieldTxtSubTitle)}}/>
                                            )}
                                            <div className="open_trading_ctas">
                                                {lowerPhotoBox.fieldLinkButton.length ? lowerPhotoBox.fieldLinkButton.map((button, index) => this.getLowerPhotoBoxLink(button, `lowerPhotoBox__${lowerPhotoBox.entityId}__${index}`)) : null}
                                            </div>
                                        </div>

                                    </div>
                                </section>

                                <section className="home__callout--center">
                                    <div className="container">

                                        <div className="callout__textModule">
                                            {bottomCallout.fieldTxtHeadline && (
                                                <h3 dangerouslySetInnerHTML={{__html: filterHTML(bottomCallout.fieldTxtHeadline)}}/>
                                            )}
                                            {bottomCallout.fieldTxtSubTitle && (
                                                <p dangerouslySetInnerHTML={{__html: filterHTML(bottomCallout.fieldTxtSubTitle)}}/>
                                            )}

                                            {bottomCallout.fieldLinkButton.length ? bottomCallout.fieldLinkButton.map((button, index) => (
                                                <a onClick={() => trackEventByUrl(button.url.path, button.title || 'Explore your possibilities')} key={`bottomCallout__${bottomCallout.entityId}__${index}`} href={button.url.path} className="button button--ghost">
                                                    {button.title || 'Explore your possibilities'}
                                                </a>
                                            )) : null}

                                        </div>

                                    </div>
                                </section>

                            </div>

                        </div>
                    );
                }}

            </Query>
        );
    }
}

export default HomePage;



// WEBPACK FOOTER //
// ./frontend/pages/Home/HomePage.jsx